export default "__VITE_ASSET__CTe544OB__"